import Vue from 'vue';
import VueScreen from 'vue-screen';

Vue.use(VueScreen, {
  notSmall: '30em',
  medium: (screen) => screen.notSmall && !screen.large,
  large: '60em',
  xlarge: '75em',
});
